import "./styles/widget.scss";

import initInput from "./input";
import initInputError from "./input_error";
import initShowMore from "./show_more";

initInput();
initInputError();
initShowMore();
